import { render, staticRenderFns } from "./ORDERCOMPLETED.vue?vue&type=template&id=ce4fbc0e"
import script from "./ORDERCOMPLETED.vue?vue&type=script&lang=js"
export * from "./ORDERCOMPLETED.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports